module.exports = __webpack_public_path__ + "static/two-99867058e75b41c2948d4a0aa102c6fd.png";